import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect } from "react";
import { emitLinkingNotification, emitUpsellNotification } from "@catchoftheday/analytics";
import { Link, toast } from "@catchoftheday/cg-components";
import { useCustomerQuery } from "@catchoftheday/customer";
import { URL_CATCH_HELP_CENTRE_SUBMIT_REQUEST } from "@header/consts";
import { getQueryStringValue } from "@header/utilities";
import { NotificationToastContainer, NotificationToastContent } from "../NotificationToast/components";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var OnePassNotification = function OnePassNotification() {
  var _membership$subscript6, _membership$subscript7;

  var _useCustomerQuery = useCustomerQuery({
    ssr: false
  }),
      data = _useCustomerQuery.data;

  var _ref = (data === null || data === void 0 ? void 0 : data.customer) || {},
      membership = _ref.membership,
      club = _ref.club;

  var containerId = "notification-toast";
  var showMessageQueryParam = getQueryStringValue("showmessage");

  var showToast = function showToast(_ref2) {
    var message = _ref2.message,
        _ref2$isError = _ref2.isError,
        isError = _ref2$isError === void 0 ? false : _ref2$isError,
        _ref2$options = _ref2.options,
        options = _ref2$options === void 0 ? {} : _ref2$options;
    toast(___EmotionJSX(NotificationToastContent, {
      message: message,
      type: isError ? "error" : "success"
    }), _objectSpread({
      containerId: containerId
    }, options));
  };

  useEffect(function () {
    if (data && (showMessageQueryParam === "u" || showMessageQueryParam === "l")) {
      var message = "";
      var toastMessage = "";
      var isError = false;

      if (!(membership !== null && membership !== void 0 && membership.linked)) {
        isError = true;
        toastMessage = ___EmotionJSX(React.Fragment, null, "There was a problem in linking your OnePass account.", ___EmotionJSX("br", null), "Please submit an", " ", ___EmotionJSX(Link, {
          href: URL_CATCH_HELP_CENTRE_SUBMIT_REQUEST,
          target: "_blank",
          color: "inherit",
          textDecoration: "underline"
        }, "enquiry for assistance"), ".");
        message = "Accounts could not be linked";
      } else {
        var _membership$subscript, _membership$subscript2, _membership$subscript3, _membership$subscript4, _membership$subscript5;

        if (!(club !== null && club !== void 0 && club.active) && !(membership !== null && membership !== void 0 && (_membership$subscript = membership.subscription) !== null && _membership$subscript !== void 0 && _membership$subscript.active)) {
          message = toastMessage = "Catch and OnePass accounts linked. No active subscription found.";
        } else if (!(club !== null && club !== void 0 && club.active) && membership !== null && membership !== void 0 && (_membership$subscript2 = membership.subscription) !== null && _membership$subscript2 !== void 0 && _membership$subscript2.active && membership !== null && membership !== void 0 && (_membership$subscript3 = membership.subscription) !== null && _membership$subscript3 !== void 0 && _membership$subscript3.onFreeTrial) {
          message = toastMessage = showMessageQueryParam === "l" ? "Catch and OnePass accounts linked." : "OnePass free trial activated.";
        } else if (!(club !== null && club !== void 0 && club.active) && membership !== null && membership !== void 0 && (_membership$subscript4 = membership.subscription) !== null && _membership$subscript4 !== void 0 && _membership$subscript4.active && !(membership !== null && membership !== void 0 && membership.subscription.onFreeTrial)) {
          message = toastMessage = showMessageQueryParam === "l" ? "Catch and OnePass accounts linked." : "OnePass subscription activated.";
        } else if (club !== null && club !== void 0 && club.active && !(membership !== null && membership !== void 0 && (_membership$subscript5 = membership.subscription) !== null && _membership$subscript5 !== void 0 && _membership$subscript5.active) && showMessageQueryParam === "l") {
          message = toastMessage = "Catch and OnePass accounts linked.";
        }
      }

      if (message) {
        if (showMessageQueryParam === "u") {
          emitUpsellNotification({
            type: isError ? "error" : "success",
            message: message
          });
        } else if (showMessageQueryParam === "l") {
          emitLinkingNotification({
            type: isError ? "error" : "success",
            message: message
          });
        }

        showToast({
          message: toastMessage,
          isError: isError,
          options: typeof toastMessage !== "string" ? {
            autoClose: false,
            closeButton: true
          } : {}
        });
      }
    }
  }, [club === null || club === void 0 ? void 0 : club.active, data, membership === null || membership === void 0 ? void 0 : membership.linked, membership === null || membership === void 0 ? void 0 : (_membership$subscript6 = membership.subscription) === null || _membership$subscript6 === void 0 ? void 0 : _membership$subscript6.active, membership === null || membership === void 0 ? void 0 : (_membership$subscript7 = membership.subscription) === null || _membership$subscript7 === void 0 ? void 0 : _membership$subscript7.onFreeTrial, showMessageQueryParam]);
  return ___EmotionJSX(NotificationToastContainer, {
    containerId: containerId
  });
};